import React from 'react'
import ReactDOM from 'react-dom'
import { Accordion, AccordionSummary, AccordionDetails, Typography, List, ListItem, ListItemText } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import bookList from '../e_bookList.json'
import { useStyles, theme } from '../styles/E_BooksStyle'

export default function E_Books() {
  const classes = useStyles()

  const ListItemLink = props => (
    <ListItem button component="a" {...props} />
  )

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>

        {/* Nonfiction Readers List */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography className={classes.heading} component="h2" className={classes.heading}>Nonfiction Readers</Typography>
          </AccordionSummary>
          {bookList.Nonfiction.map((level, index) => (
            <AccordionDetails className={classes.parentDetails} key={index}>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                >
                  {level.length > 1 ? (
                    <Typography className={classes.heading} component="h3">{`　Level ${index + 1}`}</Typography>
                  ) : (
                    <Typography className={classes.heading} component="h3">{`　Level ${index + 1}（coming soon）`}</Typography>
                  )}
                </AccordionSummary>

                {level.map((item, index) => (
                  <AccordionDetails key={index}>
                    <List component="nav" aria-label="secondary mailbox folders" className={classes.list}>
                      <ListItemLink button href={item.link} target="_blank" referrerPolicy="unsafe-url">
                        <ListItemText primary={item.title} className={classes.listItemText} />
                      </ListItemLink>
                    </List>
                  </AccordionDetails>
                ))}

              </Accordion>
            </AccordionDetails>
          ))}
        </Accordion>

        {/* Fiction Readers List */}
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
          >
            <Typography className={classes.heading}>Fiction Readers（coming soon）</Typography>
          </AccordionSummary>

          {bookList.Fiction.map((level, index) => (
            <AccordionDetails className={classes.parentDetails} key={index}>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                >
                  {level.length > 1 ? (
                    <Typography className={classes.heading} component="h3">{`　Level ${index + 1}`}</Typography>
                  ) : (
                    <Typography className={classes.heading} component="h3">{`　Level ${index + 1}（coming soon）`}</Typography>
                  )}
                </AccordionSummary>

                {level.map((item, index) => (
                  <AccordionDetails key={index}>
                    <List component="nav" aria-label="secondary mailbox folders" className={classes.list}>
                      <ListItemLink button href={item.link} target="_blank" referrerPolicy="unsafe-url">
                        <ListItemText primary={item.title} className={classes.listItemText} />
                      </ListItemLink>
                    </List>
                  </AccordionDetails>
                ))}

              </Accordion>
            </AccordionDetails>
          ))}
        </Accordion>

      </div>
    </ThemeProvider>
  )
}

if (document.getElementById('e_books')) {
  ReactDOM.render(
    <E_Books />,
    document.getElementById('e_books')
  )
}